import CaAvatar from '@yubi/yb-core-avatar';
import YbCoreTypography from '@yubi/yb-core-typography';
import { AuthService, useAuth } from '@yubi/yb-module-auth';
import { useStyles } from '@yubi/yb-style-provider';
import Grid from 'components/core/Grid';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { UserAvatarWrap } from './style';
import { YbCoreIcon } from '@yubi/yb-core-icon';

const CustomAvatar = ({}) => {
    const { userName } = AuthService.getActiveUser();
    return (
        <Grid
            item
            container
            style={{
                width: 40,
                height: 40,
                background: '#D0D5DD',
                borderRadius: '50%',
                cursor: 'pointer',
            }}
            justify="center"
            alignItems="center"
        >
            <Grid item>{userName?.charAt(0)}</Grid>
        </Grid>
    );
};

const UserAvatar = () => {
    const { styleConnector } = useStyles();
    const [showAvatarDropdown, setShowAvatarDropdown] = useState(false);
    const authedUser = useSelector((state) => state.authed.user);
    const { onLogout } = useAuth();
    const logout = () => {
        onLogout({ returnTo: process.env.REACT_APP_CREDIT_WEB_HOST });
    };
    return (
        <UserAvatarWrap item container style={{ position: 'relative' }}>
            <Grid item container onClick={() => setShowAvatarDropdown(!showAvatarDropdown)}>
                <CustomAvatar />
            </Grid>
            {showAvatarDropdown && (
                <Grid
                    item
                    container
                    style={{
                        position: 'absolute',
                        top: '100%',
                        right: 0,
                        border: '1px solid #e5e5e9',
                        borderRadius: 8,
                        padding: 12,
                        background: 'white',
                        width: 270,
                    }}
                >
                    <Grid item container direction="column" style={{ width: '100%' }}>
                        <Grid
                            item
                            container
                            style={{
                                borderBottom: '2px solid #e5e5e9',
                                paddingBottom: 8,
                                width: '100%',
                            }}
                            alignItems="center"
                        >
                            <CustomAvatar />
                            <Grid item container direction="column" style={{ marginLeft: 12 }}>
                                <YbCoreTypography
                                    size={14}
                                    weight="600"
                                    color="#384150"
                                    transform="uppercase"
                                >
                                    {authedUser?.companyName}
                                </YbCoreTypography>
                                <YbCoreTypography size={13} color="#384150">
                                    {authedUser?.name}
                                </YbCoreTypography>
                                <YbCoreTypography size={12} color="#4d6d9b" weight="600">
                                    {authedUser?.email}
                                </YbCoreTypography>
                            </Grid>
                        </Grid>
                        <Grid
                            item
                            container
                            className="avatar-menu-list"
                            direction="column"
                            style={{ padding: '8px' }}
                        >
                            <Grid
                                item
                                container
                                className="avatar-menu-list-item"
                                alignItems="center"
                                onClick={logout}
                                style={{ cursor: 'pointer' }}
                            >
                                <YbCoreIcon name="log-out-03" color="#4a5567" />
                                <YbCoreTypography
                                    color="#384150"
                                    size={14}
                                    weight="600"
                                    margin={{ left: 6 }}
                                >
                                    Logout
                                </YbCoreTypography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            )}
        </UserAvatarWrap>
    );
};

export default UserAvatar;
